import {Operator} from "../helpers/Operator";
import {Image} from "react-bootstrap";

/**
 * Zwraca obrazek z logiem operatora (przewoźnika kolejowego)
 * @param {string} agency_id
 * @returns {JSX.Element}
 * @constructor
 */
export default function OperatorLogo({agency_id}) {
    const operator = Operator.getByName(agency_id.split('_')[0]);
    if (!operator)
        return <></>
    return <Image className={"operatorLogo mx-2"} src={operator.logo} alt={operator.short}/>
}
